// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"405":"accessiblity","796":"vaping"}[chunkId] || chunkId) + "." + {"405":"b4369b9f","636":"4f034e44","796":"13b99067"}[chunkId] + ".css";
};